import script from "./sider.vue?vue&type=script&setup=true&lang=js"
export * from "./sider.vue?vue&type=script&setup=true&lang=js"

import "./sider.vue?vue&type=style&index=0&id=b6fcbc96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6fcbc96"]])

export default __exports__